// extracted by mini-css-extract-plugin
export var active = "_wx-1";
export var container = "_wx-0";
export var icon = "_wx-2";